const slotWinnerMixin = {
  data () {
    return {
      gameArray: [
        '糖果大陆', '标准五卷轴', '月光宝盒', '寻访海豚', '美女枪手', ' 功夫龙','丛林激战','名人游戏',
        '黄金工厂', ' 顶级王牌', ' 维京狂热', '上流社会', '埃及女神伊西絲', ' 招财进宝',
        '富裕人生', '迷失拉斯维加斯', '数字大转轮', '金瓶梅2', '斗牛', ' 金钱豹',
        '超级 888', ' 寿司多多', '航海时代', '喜福猴年', '泰山', ' 冒险之旅',
        '古墓丽影', '寻宝记', '双喜熊猫', '公鸡王', '泰山', ' 亚洲幻想',
        '少林宝藏', '三国拉霸', '梦幻邂逅', '表情金币', '禁忌王座', ' 花花公子'
      ],
      nameArray: [
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
      ],
      nameArr: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
      ],
      numberA: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      numberS: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      place: [
        '北京', '天津', '上海', '重庆', '河北', '山西', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '海南', '四川', '贵州', '云南', '陕西', '甘肃', '青海', '台湾', '内蒙古', '广西', '西藏', '宁夏', '新疆', '香港', '澳门'
      ],
    }
  },
  methods: {
    getTenNum (n) {
      let reslut = []
      let testArray = this.gameArray
      for (let i = 0; i < n; ++i) {
        let random = Math.floor(Math.random() * testArray.length)
        reslut.push(testArray[random])
        testArray.splice(random, 1)
      }
      return reslut
    },
    getRandom () {
      let arr = []
      // let games = this.getTenNum(10);
      for (let i = 0; i < 20; i++) {
        let game = this.gameArray[Math.floor(Math.random() * this.gameArray.length)]
        let place = this.place[Math.floor(Math.random() * this.place.length)];
        let num = parseInt(Math.random() * (2) + 7)
        let name = this.getRandomArrayElements(this.nameArray, 1).join('') + this.getRandomArrayElements(this.nameArr, num).join('')
        let moneyNum = parseInt(Math.random() * (2) + 2)
        let money = this.getRandomArrayElements(this.numberS, 2).join('') + this.getRandomArrayElements(this.numberA, moneyNum).join('')
        let obj = {}
        obj['place'] = place;
        obj['id'] = name
        obj['amount'] = money
        obj['game'] = game
        arr.push(obj)
      }
      return arr
    },
    getRandomArrayElements (arr, count) {
      let shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random())
        temp = shuffled[index]
        shuffled[index] = shuffled[i]
        shuffled[i] = temp
      }
      return shuffled.slice(min)
    }
  }
}

export default slotWinnerMixin



// WEBPACK FOOTER //
// ./src/common/mixins/random-slot-winner/slot-winner.js